import { useEffect, type ReactNode } from "react";
import { useNavigate } from "react-router-dom";

/**
 * Rendered by drill pages in coached listen mode when the session ends.
 * Shows a brief completion message and auto-navigates back to Today.
 */
export function CoachSessionDoneCard(): ReactNode {
  const navigate = useNavigate();

  useEffect(() => {
    const t = window.setTimeout(() => {
      void navigate("/review", { replace: true });
    }, 2000);
    return () => window.clearTimeout(t);
  }, [navigate]);

  return (
    <div className="max-w-2xl mx-auto py-9 px-8">
      <div className="bg-paperWarm border border-ink/10 border-l-4 border-l-success p-6">
        <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-success mb-3">
          listen session complete
        </p>
        <p className="font-serif text-xl font-medium text-ink mb-1">
          Good listening.
        </p>
        <p className="font-serif italic text-sm text-inkSoft">
          Returning to Today…
        </p>
      </div>
    </div>
  );
}
